// 布局宽度
export const LAYOUT_WIDTH = {
  ROOM_SHORTCUTS: 66, // 房间左侧边栏宽度
  FRIEND_LIST: 280, // 好友列表宽度
  DRAG_LINE: 10, // 拖拽线宽度
  SEARCH_BAR: 336, // 搜索栏宽度
  IM: 450, // 聊天窗口宽度
};

/**
 * 悬浮组件宽度
 */
export const POPOVER_WIDTH = {
  EMOJI_REPLY_LIST: 280, // 表情回应弹窗宽度
};
